export const VISIBILITY = {
    PUBLIC_ALL: 'PUBLIC_ALL',
    CUSTOMER_ONLY: 'CUSTOMER_ONLY',
    SUPPLIER_ONLY: 'SUPPLIER_ONLY',
    INTERNAL: 'INTERNAL',
};

export const NOTIFY_SHOP_IDS_KEY = 'notifyShopIds';

export const statusColorMap = {
    IN_PROGRESS: { bg: 'bgColor-accepted', text: 'text-success-700' },
    RESOLVED: { bg: 'bgColor-accepted', text: 'text-success-700' },
    CLOSED: { bg: 'bgColor-cancelled', text: 'text-danger-700' },
    CANCELED: { bg: 'bgColor-cancelled', text: 'text-danger-700' },
    OPEN: { bg: 'bgColor-pending', text: 'text-warning-700' },
    WAITING_USER: { bg: 'bgColor-pending', text: 'text-warning-700' },
};